import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import * as _ from 'lodash';
import { bindActionCreators } from 'redux';
import * as Joi from 'joi-browser';
import CustomButton from '../../common/CustomButton';
import * as accountActions from '../../../actions/accountActions';
import * as sectionActions from '../../../actions/sectionActions';
import * as messageAlert from '../../../actions/messageAlertAction';
import * as drawerActions from '../../../actions/drawerActions';
import { diff } from '../../../utils/objectUtils';
import { updateUserConfiguration } from '../../../services/api/userApi';
import { MAX_LENGTH_VARIABLES } from '../../../const';

let styles = {
  primaryButton: {
    float: 'right',
    marginRight: '24px',
    backgroundColor: props => props.colors.btnSuccess,
    '&:hover': {
      backgroundColor: props => props.colors.btnSuccessHover
    }
  },
  cancelButton: {
    float: 'right',
    marginRight: '24px',
    backgroundColor: props => props.colors.btnDefault,
    '&:hover': {
      backgroundColor: props => props.colors.btnDefaultHover
    }
  },
  disabledButton: {
    float: 'right',
    marginRight: '24px',
    pointerEvents: 'none',
    backgroundColor: props => props.colors.btnDefault
  }
};

export class ProfileFooter extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.close = this.close.bind(this);
    this.updateUserProfile = this.updateUserProfile.bind(this);
    this.formSchema = Joi.object().keys({
      email: Joi.string().email(),
      name: Joi.string(),
      surname: Joi.string(),
      picture: Joi.string(),
      avatar: Joi.string(),
      pictureType: Joi.string(),
      assetId: Joi.string(),
      language: Joi.string(),
      _id: Joi.string(),
      userId: Joi.string(),
      createdAt: Joi.any(),
      role: Joi.string(),
      connected: Joi.string()
    });
  }

  static propTypes = {
    newUserData: PropTypes.object,
    previousRoute: PropTypes.string,
    user: PropTypes.object,
    accountActions: PropTypes.any,
    sectionActions: PropTypes.any,
    colors: PropTypes.any,
    messageAlert: PropTypes.any,
    classes: PropTypes.any,
    studentProfile: PropTypes.object,
    drawerActions: PropTypes.object
  };

  close() {
    const { accountActions, user, drawerActions } = this.props;

    accountActions.setNewUserData(user);
    drawerActions.setDrawerClosed();
  }

  updateUserProfile(ev) {
    const { accountActions, drawerActions, newUserData, user, messageAlert, studentProfile } = this.props;

    const { userConfiguration, ...newUserDataWithoutConfiguration } = newUserData;
    if (userConfiguration) {
      updateUserConfiguration(user._id, userConfiguration);
      accountActions.setUserConfiguration(userConfiguration);
    }

    let updatedData = diff(user, newUserDataWithoutConfiguration);
    // If only need to update userConfiguration / else update userData
    if (Object.keys(updatedData).length === 0) {
      drawerActions.setDrawerClosed();
      return;
    }

    if (studentProfile) {
      updatedData = diff(studentProfile, newUserData);
    }
    const formValidator = Joi.validate(updatedData, this.formSchema);

    if (!formValidator.error) {
      accountActions.updateUserData();
      drawerActions.setDrawerClosed();
    } else {
      messageAlert.error(I18n.t('userProfile.invalidForm'));
    }
  }

  validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email) && email.length <= MAX_LENGTH_VARIABLES.EMAIL;
  }

  disableUploadButton() {
    const { newUserData, user, studentProfile } = this.props;

    if (_.isEmpty(newUserData.name) || _.isEmpty(newUserData.surname) || _.isEmpty(newUserData.email)) {
      return true;
    } else if (
      newUserData.name.length > MAX_LENGTH_VARIABLES.NAME ||
      newUserData.surname.length > MAX_LENGTH_VARIABLES.SURNAME ||
      newUserData.email.length > MAX_LENGTH_VARIABLES.EMAIL
    ) {
      return true;
    } else if (!this.validateEmail(newUserData.email)) {
      return true;
    }

    if (!_.isEmpty(studentProfile)) {
      return _.isEqual(studentProfile, newUserData);
    }

    return _.isEqual(user, newUserData);
  }

  renderFooter() {
    const { newUserData, classes } = this.props;

    // "newUserData" can be empty because it is fetched asynchronous and may not be initialized
    if (_.isEmpty(newUserData)) return <span />;

    return (
      <div className="user-profile-footer">
        <div onClick={this.updateUserProfile.bind(this)}>
          <CustomButton
            className={`button ${this.disableUploadButton() ? classes.disabledButton : classes.primaryButton}`}
            value={I18n.t('userProfile.footer.save')}
            disabled={false}
          />
        </div>
        <div onClick={this.close}>
          <CustomButton
            className={`button ${classes.cancelButton}`}
            value={I18n.t('userProfile.footer.cancel')}
            disabled={false}
          />
        </div>
      </div>
    );
  }

  render() {
    return this.renderFooter();
  }
}

function mapStateToProps(state) {
  return {
    user: state.account.user,
    newUserData: state.account.newUserData,
    studentProfile: state.student.selectedStudent,
    previousRoute: state.components.previousRoute,
    i18n: state.i18n,
    colors: state.theme.colors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
    sectionActions: bindActionCreators(sectionActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    drawerActions: bindActionCreators(drawerActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(ProfileFooter));
